// extracted by mini-css-extract-plugin
export default {"fullWidth":"Zo-z","image":"_o-z","lazyLoadPicture":"ap-z","lazyLoadSpinner":"bp-z","lazyLoadSpin":"cp-z","lazyLoadImage":"dp-z","hasStyledAspectRatio":"ep-z"};